import React from 'react';
import { Switch, Route } from 'react-router-dom';
import MainWrapper from './Wrapper/MainWrapper';
import PrivateRoute from './Privates/PrivateRoute';
import Dashboard from './Dashboard/Dashboard';
import Login from './Login/Login';
import Notification from './Notification/Notification';

const App = () => {
    return (
        <MainWrapper>
            <Switch>
                <Route path="/login" component={Login} />
                <PrivateRoute path="/">
                    <Dashboard />
                </PrivateRoute>
            </Switch>
            <Notification />
        </MainWrapper>
    );
};

export default App;
